import Input from "components/EvtKit/input/Input"
import SelectV2, { Option } from "components/EvtKit/select/SelectV2"

import { ChangeElement, ListElement } from "hooks/useHandleObjList"
import { selectors } from "pages/purchase-plans/constants/defaultValues"

import { memo, useCallback } from "react"
import styled from "styled-components"
import EventTypeSelector from "./selectors/EventTypeSelector"

const PricingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`

const ItemGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 16px;
`

const ItemContainer = styled.div`
  width: 100%;
  display: flex;
`

const InputContainer = styled.div`
  width: 100%;
  height: 48px;
`

interface PricingElementProps {
  item: ListElement<Partial<App.Pricings>>
  changeElement: ChangeElement<App.Pricings>
}

const PricingCalculatorVariableElement = (props: PricingElementProps) => {
  const { item, changeElement } = props

  const onSelectorChange = useCallback(
    (key: string, name: "source" | "scopeType" | "parameter") => (e: Option | null) => {
      const optionValue = e?.value ?? ""

      changeElement(key, name, optionValue)
    },
    []
  )

  return (
    <PricingContainer key={item.key}>
      <ItemGridContainer>
        <InputContainer>
          <Input
            type="text"
            name="variableNameInExpression"
            label="Variável"
            className="fullWidth"
            value={item.variableNameInExpression}
            readOnly
            shrink
          />
        </InputContainer>

        <ItemContainer>
          <EventTypeSelector onSelectorChange={onSelectorChange(item.key, "source")} value={item.source} />
        </ItemContainer>

        <ItemContainer>
          <SelectV2
            className="fullWidth"
            id="scopeType"
            label="Tipo de escopo *"
            options={selectors.scopeTypeOptionsCalculator}
            placeholder="Selecione"
            shrink
            value={item.scopeType || ""}
            onChange={onSelectorChange(item.key, "scopeType")}
          />
        </ItemContainer>

        {item.scopeType === "event-type" && (
          <ItemContainer>
            <SelectV2
              className="fullWidth"
              id="parameter"
              label="Parâmetro *"
              options={selectors.parametersOptionsCalculator}
              placeholder="Selecione"
              shrink
              value={item.parameter || ""}
              onChange={onSelectorChange(item.key, "parameter")}
            />
          </ItemContainer>
        )}
      </ItemGridContainer>
    </PricingContainer>
  )
}

export default memo(PricingCalculatorVariableElement)
